// `/relances` index — D-Wave Batch 4 D25 (Q4: relances promoted to top-level
// sidebar slot). Bare entry redirects to `/relances/pending` so the sidebar
// link always lands on the only existing sub-page; mirrors the
// `/settings → /settings/profile` pattern.

import { createRoute, redirect } from '@tanstack/react-router';

import { Route as RelancesLayoutRoute } from './__layout';

export const Route = createRoute({
  getParentRoute: () => RelancesLayoutRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/relances/pending' });
  },
  component: () => null,
});
